// extracted by mini-css-extract-plugin
export default {"error-border":"Signup_error-border__+gWbf"};